import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../../translate/translate.pipe.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ProjectInfosComponent } from './project-infos.component';
import { NgxSelectModule } from 'ngx-select-ex';
import { FileChooserModule} from '../../FileChooser/file-chooser.module';
import {ImportDuplicateModalModule} from '../../import-duplicate-modal/import-duplicate-modal.module';
import {MaterialChipsInputModule} from '../tags/materialChipsInput.module';
import {BreadCrumbModule} from '../../bread-crumb/bread-crumb.module';
import {GenericModalModule} from '../../modal/generic-modal.module';
import {SharedRefreshService} from '../../service/sharedRefreshService';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslatePipeModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSelectModule,
        FileChooserModule,
        ImportDuplicateModalModule,
        MaterialChipsInputModule,
        BreadCrumbModule,
        GenericModalModule
    ],
  declarations: [ProjectInfosComponent],
  providers: [SharedRefreshService],
  exports: [ProjectInfosComponent]
})

export class ProjectInfosModule {

}
